import { ref } from 'vue'
import { useCampaignService } from '@/services/campaign/useCampaignService'
import { TypeCampaign } from '@/services/campaign/enums/type-campaign.enum'
import type { IOptionsCampaign } from '@/services/campaign/interfaces/options-campaign.interface'

export interface CampaignOption {
  id: string
  name: string
  type?: TypeCampaign
}

export interface UserOption {
  id: string
  name: string
  email?: string
  avatar?: string | null
}

export const useTransferDialog = () => {
  const campaignService = useCampaignService()

  const campaigns = ref<CampaignOption[]>([])
  const users = ref<UserOption[]>([])
  const isLoadingCampaigns = ref(false)
  const isLoadingUsers = ref(false)
  const error = ref<string | null>(null)

  const loadWhatsAppCampaigns = async (_currentUserId?: string) => {
    isLoadingCampaigns.value = true
    error.value = null

    try {
      const response = await campaignService.getAllCampaigns({
        campaign_type: TypeCampaign.WHATSAPP,
      })

      campaigns.value = response.map((campaign: IOptionsCampaign) => ({
        id: campaign.id,
        name: campaign.name,
        type: campaign.type,
      }))

      return campaigns.value
    } catch (err) {
      error.value = 'Error al cargar las campañas'
      campaigns.value = []
      return []
    } finally {
      isLoadingCampaigns.value = false
    }
  }

  const loadCampaignUsers = async (campaignId: string, excludeUserId?: string) => {
    isLoadingUsers.value = true
    error.value = null

    try {
      const response = await campaignService.getCampaignUsers(campaignId)

      users.value = response
        .filter((user) => user.id !== excludeUserId)
        .map((user) => ({
          id: user.id,
          name: user.name,
          email: user.email,
          avatar: user.avatar,
        }))

      return users.value
    } catch (err) {
      error.value = 'Error al cargar los usuarios de la campaña'
      users.value = []
      return []
    } finally {
      isLoadingUsers.value = false
    }
  }

  const reset = () => {
    campaigns.value = []
    users.value = []
    error.value = null
    isLoadingCampaigns.value = false
    isLoadingUsers.value = false
  }

  return {
    campaigns,
    users,
    isLoadingCampaigns,
    isLoadingUsers,
    error,
    loadWhatsAppCampaigns,
    loadCampaignUsers,
    reset,
  }
}
